import {
  AlignItems,
  Box,
  Color,
  Display,
  DisplayPosition,
  FlexDirection,
  FontFamily,
  FontWeight,
  ResponsiveValue,
  Space,
  Text,
} from '@gousto-internal/citrus-react'
import React from 'react'
import { FourWayImage } from '../FourWayImage/FourWayImage'
import { RecipeTag } from '../RecipeTag/RecipeTag'
import {
  ArrowIcon,
  ArrowIconTile,
  RecipeTitleRow,
  CarouselItemBox,
} from './CuratedBoxCarouselItem.styled'

export type TopInStockRecipe = {
  recipeId: string
  recipeImageSrc: string
}

export type CuratedBox = {
  type: string
  id: string
  curatedBoxCollectionId: string
  title: string
  tags: string[]
  topInStockRecipes: (TopInStockRecipe | undefined)[]
}

type CuratedBoxCarouselItemProps = {
  carouselItem: CuratedBox
  handleOnClick: (
    curatedBoxRecipes: string[],
    curatedBoxCollectionId: string,
    curatedBoxName: string,
    index: number,
  ) => void
  index: number
  carouselIsMoving: boolean
}

const RecipeTagRow = ({ recipeTags }: { recipeTags: string[] }) => (
  <Box paddingH={[2, null]} display={Display.Flex}>
    {recipeTags.map((recipeTag) => (
      <Box paddingRight={[2, null, 1]} key={recipeTag}>
        <RecipeTag key={recipeTag} tagText={recipeTag} />
      </Box>
    ))}
  </Box>
)

const IconBox = () => (
  <Box borderRadius={1.5} bg={Color.White} paddingH={1} paddingV={1}>
    <ArrowIconTile>
      <ArrowIcon size={5} name="add" />
    </ArrowIconTile>
  </Box>
)

export const CuratedBoxCarouselItem = ({
  carouselItem,
  handleOnClick,
  index,
  carouselIsMoving,
}: CuratedBoxCarouselItemProps) => {
  const { topInStockRecipes, tags, title, curatedBoxCollectionId } = carouselItem
  const bottomSpacing = '46px'

  const curatedBoxImgUrls = topInStockRecipes.map((item) => item?.recipeImageSrc)

  const onKeyPress = (event: React.KeyboardEvent<HTMLElement>) => {
    if (event.key === 'Enter') {
      onClick()
    }
  }
  const onClick = () => {
    // this prevents click events from bubbling up when a user is dragging/moving the carousel
    // without this, any 'drag' event will also fire an 'onClick' event.
    if (carouselIsMoving) return
    const recipeIds = topInStockRecipes.map((recipe) => recipe?.recipeId) as string[]
    handleOnClick(recipeIds, curatedBoxCollectionId, title, index)
  }
  return (
    <Box
      data-testid="curatedBoxCarouselItem"
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyPress={onKeyPress}
      width={['230px', null, '250px', '377px']}
      position={DisplayPosition.Relative}
    >
      <CarouselItemBox>
        <FourWayImage curatedBoxImgUrls={curatedBoxImgUrls} />
        <Box
          position={DisplayPosition.Absolute}
          height="24px"
          bottom={bottomSpacing as ResponsiveValue<string>}
          left="1px"
        >
          <RecipeTagRow recipeTags={tags} />
        </Box>
        <Box
          position={DisplayPosition.Absolute}
          height="24px"
          bottom={bottomSpacing as ResponsiveValue<string>}
          left="1px"
        >
          <RecipeTagRow recipeTags={tags} />
        </Box>
        <Box
          position={DisplayPosition.Absolute}
          display={Display.Flex}
          flexDirection={FlexDirection.Row}
          alignItems={AlignItems.Center}
          height="24px"
          bottom={bottomSpacing as ResponsiveValue<string>}
          right={['1px', '1px', '5px']}
        >
          <IconBox />
        </Box>
        <RecipeTitleRow>
          <Box paddingH={3} paddingV={3}>
            <Space size={2} />
            <Text size={3} fontFamily={FontFamily.Bold} fontWeight={FontWeight.SemiBold}>
              {title}
            </Text>
          </Box>
        </RecipeTitleRow>
      </CarouselItemBox>
    </Box>
  )
}
